import styled from 'styled-components';

export const StyledLogoContainer = styled.div`
  height: 48px;
  min-height: 48px;
  display: flex;
  align-items: center;
  background-color: #232323;
  padding-left: 16px;
`;
